import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { papi, perr, setTok, ORG_KEY } from "@/lib/patientApi";
import { setSpace } from "@/lib/space";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";

// Formulaire de connexion patient : uniquement patientApi (auth, session et endpoints séparés de l'entreprise).
export function PatientLoginForm() {
  const nav = useNavigate();
  const [f, setF] = useState({ email: "", password: "", organization_id: localStorage.getItem(ORG_KEY) || null });
  const [orgs, setOrgs] = useState(null);
  const [busy, setBusy] = useState(false);
  const go = async (e, org) => {
    e?.preventDefault?.();
    setBusy(true);
    try {
      const { data } = await papi.post("/patient/auth/login", { ...f, organization_id: org ?? f.organization_id });
      setTok(data.access_token); localStorage.setItem(ORG_KEY, data.patient.organization_id); setSpace("patient");
      nav("/patient", { replace: true });
    } catch (err) {
      const d = err.response?.data?.detail;
      if (d?.code === "choose_organization") setOrgs(d.organizations);
      else { toast.error(perr(err)); if (err.response?.status === 401) setF({ ...f, organization_id: null }); }
    } finally { setBusy(false); }
  };
  return (
    <form onSubmit={go} className="space-y-4" data-testid="patient-login">
      <p className="text-sm text-slate-500">Accès réservé aux patients invités par leur entreprise de transport.</p>
      <div><Label htmlFor="p-email" className="text-slate-700">Email</Label><Input id="p-email" data-testid="patient-login-email" type="email" inputMode="email" autoComplete="username" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} className="h-14 text-base mt-1 bg-white" required /></div>
      <div><Label htmlFor="p-password" className="text-slate-700">Mot de passe</Label><Input id="p-password" data-testid="patient-login-password" type="password" autoComplete="current-password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} className="h-14 text-base mt-1 bg-white" required /></div>
      {orgs && <div data-testid="patient-login-orgs" className="space-y-2"><p className="text-sm font-bold text-slate-700">Choisissez votre entreprise :</p>{orgs.map((o) => <button type="button" key={o.id} data-testid={`patient-login-org-${o.id}`} onClick={(e) => go(e, o.id)} className="w-full h-12 rounded-xl border-2 border-green-200 font-bold text-green-900">{o.name}</button>)}</div>}
      <button type="submit" data-testid="patient-login-submit" disabled={busy} className="h-14 w-full rounded-xl bg-green-600 hover:bg-green-700 text-white text-base font-bold flex items-center justify-center gap-2 disabled:opacity-50 transition-colors">{busy ? <Loader2 className="w-5 h-5 animate-spin" /> : "Se connecter"}</button>
      <Link to="/patient/mot-de-passe-oublie" data-testid="patient-forgot-link" className="block text-center text-sm font-semibold text-green-700 underline pt-1">Mot de passe oublié ?</Link>
    </form>
  );
}
